"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mergeTranslations = void 0;
/**
 * Merges fetched translations without namespaces into default translations with namespaces.
 * This function combines the fetched translations with the default translations, using
 * the specified packageId (namespace) to locate and update the translations within that namespace.
 *
 * @typeParam T Type representing translations with namespaces.
 * @param defaultTranslationsWithNamespaces An object containing translations organized by
 * namespaces. The keys of this object represent the namespaces, and the values are objects containing
 * key-value pairs of translations.
 * @param fetchedTranslationsWithoutNamespaces An object containing translations
 * without namespaces. Each key represents a translation key, and the value represents the translated
 * value.
 * @param packageId The specific namespace in which to check for existing keys and update translations.
 * @returns Merged translations with namespaces.
 */
const mergeTranslations = (defaultTranslationsWithNamespaces, fetchedTranslationsWithoutNamespaces, packageId) => {
  const output = JSON.parse(JSON.stringify(defaultTranslationsWithNamespaces));

  // Ensure the specified namespace exists in the output
  if (output[packageId]) {
    const translations = output[packageId];
    for (const key in translations) {
      if (Object.hasOwn(translations, key)) {
        const defaultValue = translations[key];
        const translatedValue = fetchedTranslationsWithoutNamespaces[key];

        // Only assign to translations[key] if a valid string is present
        if (translatedValue != null) {
          translations[key] = translatedValue;
        } else if (defaultValue != null) {
          translations[key] = defaultValue;
        }
      }
    }
    output[packageId] = translations;
  }
  return output;
};
exports.mergeTranslations = mergeTranslations;
//# sourceMappingURL=mergeTranslations.js.map